const GET_USER_ACTIVITY = 'usuarios/activity/GET_USER_ACTIVITY';
const GET_USER_ACTIVITY_COMPLETED = 'usuarios/activity/GET_USER_ACTIVITY_COMPLETED';
const GET_USER_ACTIVITY_FAILED = 'usuarios/activity/GET_USER_ACTIVITY_FAILED';

const GET_MESSAGES_UNREAD = 'usuarios/activity/GET_MESSAGES_UNREAD';
const GET_MESSAGES_UNREAD_COMPLETED = 'usuarios/activity/GET_MESSAGES_UNREAD_COMPLETED';
const GET_MESSAGES_UNREAD_FAILED = 'usuarios/activity/GET_MESSAGES_UNREAD_FAILED';

const GET_FREQUENCIES = 'usuarios/activity/GET_FREQUENCIES';
const GET_FREQUENCIES_COMPLETED = 'usuarios/activity/GET_FREQUENCIES_COMPLETED';
const GET_FREQUENCIES_FAILED = 'usuarios/activity/GET_FREQUENCIES_FAILED';

const PUT_USER_ACTIVITY = 'usuarios/activity/PUT_USER_ACTIVITY';
const PUT_USER_ACTIVITY_COMPLETED = 'usuarios/activity/PUT_USER_ACTIVITY_COMPLETED';
const PUT_USER_ACTIVITY_FAILED = 'usuarios/activity/PUT_USER_ACTIVITY_FAILED';

const DELETE_USER_ACTIVITY = 'usuarios/activity/DELETE_USER_ACTIVITY';
const DELETE_USER_ACTIVITY_COMPLETED = 'usuarios/activity/DELETE_USER_ACTIVITY_COMPLETED';
const DELETE_USER_ACTIVITY_FAILED = 'usuarios/activity/DELETE_USER_ACTIVITY_FAILED';

export {
  GET_USER_ACTIVITY,
  GET_USER_ACTIVITY_COMPLETED,
  GET_USER_ACTIVITY_FAILED,
  PUT_USER_ACTIVITY,
  PUT_USER_ACTIVITY_COMPLETED,
  PUT_USER_ACTIVITY_FAILED,
  DELETE_USER_ACTIVITY,
  DELETE_USER_ACTIVITY_COMPLETED,
  DELETE_USER_ACTIVITY_FAILED,
  GET_FREQUENCIES,
  GET_FREQUENCIES_COMPLETED,
  GET_FREQUENCIES_FAILED,
  GET_MESSAGES_UNREAD,
  GET_MESSAGES_UNREAD_COMPLETED,
  GET_MESSAGES_UNREAD_FAILED
};
